<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('paymentTesting.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('paymentTesting.pageTitle'), href: '/payment-testing' },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-6">
              <form class="ts-h-full">
                <fieldset class="ts-h-full">
                  <legend>{{ $t('paymentTesting.studentInquiry') }}</legend>
                  <inquery-search v-model="model" />
                </fieldset>
              </form>
            </div>
            <div class="col-md-6">
              <form class="form-horizontal ts-h-full">
                <fieldset class="ts-h-full">
                  <legend>{{ $t('paymentTesting.paymentInfo') }}</legend>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="required ts-mb-0">{{
                        $t('paymentTesting.date')
                      }}</label>
                      <a-date-picker
                        v-model="model.payment_date"
                        style="width:100%"
                        format="DD-MM-YYYY"
                      ></a-date-picker>
                      <div class="validate" v-if="errors.has('payment_date')">
                        {{ errors.first('payment_date') }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="required ts-mb-0">{{
                        $t('paymentTesting.student')
                      }}</label>
                      <input
                        v-model="model.student_name"
                        type="text"
                        class="form-control"
                        readonly
                      />
                      <div class="validate" v-if="errors.has('inquiry_id')">
                        {{ errors.first('inquiry_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row ts-mt-3">
                    <div class="col-md-6">
                      <label class="required ts-mb-0">{{
                        $t('paymentTesting.subProgram')
                      }}</label>
                      <a-select
                        v-model.number="model.acps_id"
                        show-search
                        optionFilterProp="children"
                        :default-active-first-option="false"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        :options="subProgramList"
                        @change="onSubProgramChange"
                      ></a-select>
                      <div class="validate" v-if="errors.has('acps_id')">
                        {{ errors.first('acps_id') }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="required ts-mb-0">{{
                        $t('paymentTesting.academicTerm')
                      }}</label>
                      <a-select
                        v-model.number="model.ac_term_id"
                        :loading="fetch_ac_term"
                        :options="ac_term_lists"
                        @change="handleActermchange"
                      ></a-select>
                      <div class="validate" v-if="errors.has('ac_term_id')">
                        {{ errors.first('ac_term_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row ts-mt-3">
                    <div class="col-md-6">
                      <label class="required ts-mb-0">{{
                        $t('paymentTesting.paymentMethod')
                      }}</label>
                      <a-select
                        v-model.number="model.payment_method_id"
                        show-search
                        optionFilterProp="children"
                        :default-active-first-option="false"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        :options="paymentMethods"
                        @change="onPaymentMethodChange"
                      ></a-select>
                      <div
                        class="validate"
                        v-if="errors.has('payment_method_id')"
                      >
                        {{ errors.first('payment_method_id') }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="required ts-mb-0">{{
                        $t('paymentTesting.amount')
                      }}</label>
                      <input
                        v-model.number="model.payment_amount"
                        type="number"
                        step="any"
                        class="form-control"
                      />
                      <div class="validate" v-if="errors.has('payment_amount')">
                        {{ errors.first('payment_amount') }}
                      </div>
                    </div>
                  </div>
                  <div class="row ts-mt-3">
                    <div class="col-md-6">
                      <label class="required ts-mb-0">{{
                        $t('paymentTesting.bank')
                      }}</label>
                      <a-select
                        v-model.number="model.bank_id"
                        show-search
                        optionFilterProp="children"
                        :default-active-first-option="false"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        :options="branchList"
                        @change="() => model.bank_account_id = null"
                        :disabled="model.payment_method_id === 1"
                      ></a-select>
                      <div class="validate" v-if="errors.has('bank_id')">
                        {{ errors.first('bank_id') }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="required ts-mb-0">{{
                        $t('paymentTesting.accountNumber')
                      }}</label>
                      <a-select
                        v-model.number="model.bank_account_id"
                        show-search
                        optionFilterProp="children"
                        :default-active-first-option="false"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        :options="accountNumberList"
                         :disabled="model.payment_method_id === 1"
                      ></a-select>
                      <div
                        class="validate"
                        v-if="errors.has('bank_account_id')"
                      >
                        {{ errors.first('bank_account_id') }}
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <panel :title="$t('paymentTesting.item')">
                <item-details v-model="model" :validate="errors" />
                <div class="row mt-3">
                  <div class="col-md-12 text-right">
                    <ts-button
                      class="mr-2"
                      @click="$router.push({ name: 'payment-test' })"
                      >{{ $t('cancel') }}</ts-button
                    >
                    <ts-button
                      color="primary"
                      outline
                      class="mr-2"
                      :waiting="waiting_print"
                      @click.prevent="savePrint"
                      >{{ $t('savePrint') }}</ts-button
                    >
                    <ts-button
                      color="primary"
                      :waiting="waiting"
                      @click.prevent="onSave"
                      >{{ $t('save') }}</ts-button
                    >
                  </div>
                </div>
              </panel>
              <div class="validate" v-if="errors.has('fee_detail_list')">
                {{ errors.first('fee_detail_list') }}
              </div>
            </div>
          </div>
          <!-- preview pdf -->
          <a-modal
            v-model="preview_pdf"
            :title="$t('pdf')"
            @cancel="() => (preview_pdf = false)"
            width="35%"
            :maskClosable="false"
            :footer="null"
            :zIndex="1020"
          >
            <preview-pdf-component :id="id" />
          </a-modal>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import InquerySearch from './components/inquire_search'
import ItemDetails from './components/item-details'
import PreviewPdfComponent from './components/pdf-preview'
import moment from 'moment'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'createPaymentTesting',
  components: {
    InquerySearch,
    ItemDetails,
    PreviewPdfComponent
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_print: false,
      fetch_ac_term: false,
      preview_pdf: false,
      id: null,
      ac_term_lists: [],
      banks: [],
      model: {
        payment_date: moment(),
        inquiry_id: null,
        student_name: null,
        ac_year_id: null,
        ac_term_id: null,
        acps_id: null,
        payment_amount: null,
        payment_method_id: 1,
        bank_id: null,
        bank_account_id: null,
        fee_detail_list: []
      }
    }
  },
  created() {
    this.loading = true
    this.fetchBeforeCreate()
  },
  computed: {
    subProgramList() {
      return this.$store.state.paymentTesting.subPrograms.map(el => ({
        value: el.acps_id,
        label: el.acps_name_foreign
      }))
    },
    branchList() {
      return this.banks.map(el => ({
        value: el.bank_id,
        label: el.bank_name
      }))
    },
    accountNumberList() {
      const bank = this.banks.find(b => b.bank_id === this.model.bank_id)
      if (bank !== undefined) {
        return bank.bank_accounts.map(acc => ({
          value: acc.account_id,
          label: acc.account_number + '-' + acc.account_name
        }))
      }
      return []
    },
    paymentMethods() {
      return [
        { value: 1, label: 'Cash' },
        { value: 2, label: 'Cheque' },
        { value: 3, label: 'Bank Transfer' },
        { value: 4, label: 'Credit Card' }
      ]
    }
  },
  methods: {
    ...mapActions('paymentTesting', [
      'getFeeSetup',
      'getSubProgram',
      'formViewModel',
      'getTermBySub',
      'store'
    ]),
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$router.push({ name: 'payment-test' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    savePrint() {
      this.errors = new Errors()
      this.waiting_print = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.preview_pdf = true
          this.id = response.id
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting_print = false
        })
    },
    async fetchBeforeCreate() {
      await this.getFeeSetup()
      await this.getSubProgram()
      await this.fetchFormModel()
      this.loading = false
    },
    async fetchFormModel() {
      this.formViewModel({
        fnName: 'bank'
      })
        .then(response => {
          this.banks = response.data.bank
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    onSubProgramChange(acpsId) {
      this.model.ac_term_id = null
      this.model.ac_year_id = null
      this.ac_term_lists = []

      this.fetch_ac_term = true
      this.getTermBySub(acpsId)
        .then(response => {
          this.ac_term_lists = response.data.map(el => ({
            value: el.ac_term_id,
            label: el.term_name,
            ac_year_id: el.ac_year_id
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetch_ac_term = false
        })
    },
    handleActermchange(acTermId) {
      this.model.ac_year_id = this.ac_term_lists
        .filter(ac => ac.value == acTermId)
        .reduce((init, item) => (init = item.ac_year_id), null)
    },
    onPaymentMethodChange(){
      this.model.bank_id = null;
      this.model.bank_account_id = null;
    },
    clearInput() {
      this.errors = new Errors();
      this.model.payment_date = moment();
      this.model.inquiry_id = null;
      this.model.student_name = null;
      this.model.ac_year_id = null;
      this.model.ac_term_id = null;
      this.model.acps_id = null;
      this.model.payment_amount = null;
      this.model.payment_method_id = 1;
      this.model.bank_id = null;
      this.model.bank_account_id = null;
      this.model.fee_detail_list = [];
    }
  },
  watch: {
    'model.inquiry_id': function() {
      if (this.model.acps_id) {
        this.onSubProgramChange(this.model.acps_id)
      }
    }
  }
}
</script>
